const _none = "0"
const _sm = "2px"
const _DEFAULT = "4px"
const _md = "8px"
const _lg = "12px"
const _xl = "24px"
const _2xl = "30px"
const _3xl = "60px"
const _full = "9999px"
const _badge = "var(--rounded-badge, 1.9rem)"
const _btn = "var(--rounded-btn, 0.5rem)"
const _box = "var(--rounded-box, 1rem)"
const config = { "none": _none, "sm": _sm, "DEFAULT": _DEFAULT, "md": _md, "lg": _lg, "xl": _xl, "2xl": _2xl, "3xl": _3xl, "full": _full, "badge": _badge, "btn": _btn, "box": _box,  }
export { config as default, _none, _sm, _DEFAULT, _md, _lg, _xl, _2xl, _3xl, _full, _badge, _btn, _box }